import { Inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IEntity } from '@interfaces/entity';


@Injectable()
export class SelectEntitiesService {
  selectedEntities: IEntity[];

  constructor() {
    this.selectedEntities = [];
  }

  addEntity(entity) {
    this.selectedEntities.push(entity);
  }

  addEntities(entities) {
    this.selectedEntities = this.selectedEntities.concat(entities);
  }

  removeEntity(entity: IEntity) {
    var index: number;

    index = this.selectedEntities.findIndex(e => e.getPrimaryKey() === entity.getPrimaryKey());

    if (index !== -1) {
      this.selectedEntities.splice(index, 1);
    }
  }

  clearEntities() {
    this.selectedEntities = [];
  }

  getSelectedIds(): string {
    var selectedIds = "";

    for (let entity of this.selectedEntities) {
      selectedIds = selectedIds.concat(String(entity.getPrimaryKey()) + ",");
    }

    var lastChar = selectedIds.substr(selectedIds.length - 1);

    if (lastChar == ",") {
      selectedIds = selectedIds.slice(0, -1);
    }

    return selectedIds;
  }

  checkIfSelected(entity): boolean {
    if (this.selectedEntities.some(e => e.getPrimaryKey() === entity.getPrimaryKey())) {
      return true;
    }
    return false;
  }

  entityClicked(entity) {
    var checkboxAllElement = (<HTMLInputElement>document.getElementById("checkbox-all"));
    checkboxAllElement.checked = true;

    if (this.selectedEntities.some(e => e.getPrimaryKey() === entity.getPrimaryKey())) {
      this.removeEntity(entity);
    }
    else {
      this.addEntity(entity);
    }

    if (this.selectedEntities.length == 0) {
      checkboxAllElement.checked = false;
    }
  }

  checkboxAllClicked(entities$: Observable<IEntity[]>) {
    var checkboxAllElement = (<HTMLInputElement>document.getElementById("checkbox-all"));

    var entities: IEntity[];
    entities$.subscribe(result => { entities = result });

    this.clearEntities();

    if (checkboxAllElement.checked) {
      this.addEntities(entities);
    }
  }

  onPageChange() {
    var checkboxAllElement = (<HTMLInputElement>document.getElementById("checkbox-all"));
    this.clearEntities();
    checkboxAllElement.checked = false;
  }
}
